export const environment = {
  production: true,
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  clientId: "90bb9eea-023a-4186-9003-f8c1e8284bee",
  redirectUri: "https://WIMS.azure.chevron.com",
  wimsApi: "https://WIMS-api.azure.chevron.com/api/",
  apiScope: "https://WIMS.azure.chevron.com/user_impersonation",
  isIE:
    window.navigator.userAgent.indexOf("MSIE ") > -1 ||
    window.navigator.userAgent.indexOf("Trident/") > -1,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import "zone.js/plugins/zone-error"; // Included with Angular CLI.
